import { render } from "./ScreenshotPopup.vue?vue&type=template&id=2be19531&scoped=true"
import script from "./ScreenshotPopup.vue?vue&type=script&lang=js"
export * from "./ScreenshotPopup.vue?vue&type=script&lang=js"

import "./ScreenshotPopup.vue?vue&type=style&index=0&id=2be19531&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be19531"]])

export default __exports__